"use strict";
var $ = require("../internals/export");
var fails = require("../internals/fails");
var getOwnPropertyNames = require("../internals/object-get-own-property-names-external").f;
var FAILS_ON_PRIMITIVES = fails(function() {
  return !Object.getOwnPropertyNames(1);
});
$({ target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames
});
